import React, { useState, useEffect } from 'react';
import './addHoliday.css';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { formatISO, startOfDay } from 'date-fns';
import { useTranslation } from 'react-i18next';
import axiosInstance from '../../../utils/axiosInstance';
import { Form, Button } from 'react-bootstrap';

export const AddHoliday = ({ selectedDate, holiday, companyId }) => {

    const { t } = useTranslation();
    const [reason, setReason] = useState('');
    const [isRequestVisible, setIsRequestVisible] = useState(true); // Set this to true initially
    const [actionMessage, setActionMessage] = useState('');
    const [branches, setBranches] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState('');

    // Fetch branches when a company is selected
    useEffect(() => {
        if (companyId) {
            axiosInstance.get(`/user/branches/${companyId}`)
                .then(response => setBranches(response.data))
                .catch(error => console.error('Error fetching branches:', error));
        } else {
            setBranches([]);
            setSelectedBranch('');
        }
    }, [companyId]);

    useEffect(() => {
        if (holiday) {
            setReason(holiday.occasion);
            setSelectedBranch(holiday.branchId)
        } else {
            setReason('');
            setSelectedBranch('');
        }
    }, [holiday]);

    const handleBranchChange = (e) => {
        setSelectedBranch(e.target.value);
    };

    const handleInputChange = (event) => {
        const { value } = event.target;

        // Split the input value into words
        const words = value.trim().split(/\s+/); // Split by whitespace

        // Check if the input meets the criteria: <= 15 characters and 2 words
        if (value.length <= 100 && words.length <= 10) {
            setReason(value); // Update state with the valid input
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const holidayDate = formatISO(startOfDay(selectedDate), { representation: 'date' });
        const holidayOccasion = reason;

        try {
            setActionMessage('Adding Holiday...');
            await axiosInstance.post('/admin/add-holiday', {
                holiday_date: holidayDate,
                holiday_occasion: holidayOccasion,
                company_id: companyId,
                branch_id: selectedBranch || null, // Include selectedBranch
            });
            toast.success(t("manageHolidays_addtoast"));
            setReason('');
            setSelectedBranch('')
            setActionMessage('');
            window.location.reload();
        } catch (error) {
            toast.error('Error adding holiday. Please try again.');
        }
    };

    const handleEdit = async (e) => {
        e.preventDefault();
        const holidayDate = formatISO(startOfDay(selectedDate), { representation: 'date' });
        const holidayOccasion = reason;

        try {
            setActionMessage(t("manageHolidays_editToast"));
            await axiosInstance.put(`/admin/edit-holiday/${holidayDate}`, {
                holiday_date: holidayDate,
                holiday_occasion: holidayOccasion,
                company_id: companyId,
                branch_id: selectedBranch || null, // Include selectedBranch
            });
            toast.success('Holiday edited');
            setReason('');
            setSelectedBranch('')
            setActionMessage('');
            window.location.reload();
        } catch (error) {
            toast.error('Error editing holiday. Please try again.');
        }
    };

    const handleDelete = async () => {
        try {
            // const formattedDate = formatISO(startOfDay(selectedDate), { representation: 'date' });
            setActionMessage('Deleting Holiday...');
            await axiosInstance.delete(`/admin/delete-holiday/${holiday.holidayId}`);
            toast.success('Holiday deleted');
            setReason('');
            setSelectedBranch('')
            setActionMessage('');
            window.location.reload();
        } catch (error) {
            toast.error('Error deleting holiday. Please try again.');
        }
    };

    const handleCancel = () => {
        setIsRequestVisible(false);
        setReason('');
        setSelectedBranch('')
    };

    return (
        <div className="holiday-form-request">
            <div className="addHoliday-details-header">
                {selectedDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </div>
            <div className="addHoliday-header">
                {holiday ? t("manageHolidays_editTitle") : t("manageHolidays_addTitle")}
            </div>
            <Form className="addHoliday-form" onSubmit={holiday ? handleEdit : handleSubmit}>
                <Form.Group controlId="holidayName">
                    <Form.Label style={{ fontSize: '12px' }}>{t("Holiday Name")}:</Form.Label>
                    <Form.Control
                        as="textarea"
                        style={{ height: 50, fontSize: '12px', color: '#757575' }}
                        name="Occasion"
                        placeholder={t("manageHolidays_placeholder")}
                        value={reason}
                        onChange={handleInputChange}
                        maxLength={100}
                        required
                    />
                </Form.Group>
                <Form.Group controlId="branch">
                    <Form.Label style={{ fontSize: '12px' }}>{t("Branch")}:</Form.Label>
                    <Form.Select
                        value={selectedBranch}
                        onChange={handleBranchChange}
                        disabled={!branches.length}
                        style={{ fontSize: '12px', color: '#757575' }}
                    >
                        <option value="">{t("Select Branch")}</option>
                        {branches.map(branch => (
                            <option key={branch.branch_id} value={branch.branch_id}>
                                {branch.branch_name}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>

                <div className='addHoliday-form-buttons'>
                    <Button className="HolidaySaveBtn" type="submit">
                        {holiday ? t("addProject_save") : t("empForm_submit")}
                    </Button>
                    <Button className='holidayCancel' type="button" onClick={handleCancel}>
                        {t("addProject_cancel")}
                    </Button>
                    {holiday && (
                        <Button className="HolidayDeleBtn" type="button" onClick={handleDelete}>
                            {t("manageProject_deleteBtn")}
                        </Button>
                    )}
                </div>
            </Form>
            {actionMessage && <div>{actionMessage}</div>}
        </div>
    )
}
